// extracted by mini-css-extract-plugin
export default {"button":"en-z","reviewSort":"fn-z"};